import $ from 'jquery';

const Menu = (el) => {
    $(el).on('click', () => {
        const toggleElement = el.dataset.toggle;
        $('html').toggleClass('no-scroll');
        $('body').toggleClass('js-menu-active');
        $(toggleElement).toggleClass('active');
    });

    $('.js-toggle-children').on('click', (e) => {
        const target = e.currentTarget;
        if ($(target).attr('href') === '#') {
            e.preventDefault();
            const parent = $(target).parent();
            const children = $(target).next('.menu__children');
            $('.menu__item').not(parent).removeClass('menu__item--active');
            $('.menu__children').not(children).hide();
            parent.toggleClass('menu__item--active');
            children.toggle({
                duration: 0,
                complete: function () {
                    $(this).is(':visible')
                        ? $('.js-header').addClass('header--active')
                        : $('.js-header').removeClass('header--active');
                },
            });
        }
    });

    const $menu = $('.menu');

    // Close menu when clicking outside
    $(document).on('click', (e) => {
        if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
            closeMenu();
        }
    });

    // Close menu when all .menu__children lose focus
    $('.menu__children').on('focusout', function () {
        const $this = $(this);
        setTimeout(() => {
            if ($this.find(':focus').length === 0) {
                closeMenu();
            }
        }, 10); // Short delay to allow focus change before checking
    });

    function closeMenu() {
        $('.js-header').removeClass('header--active');
        $('.menu__item').removeClass('menu__item--active');
        $('.menu__children').hide();
    }
};

export default Menu;
